angular.module('picmonicng').component('homePresentations', {
  templateUrl: '/templates/app/components/home-presentations/home-presentations.html',
  bindings: {},
  controller: [
    '$rootScope',
    '$scope',
    '$modal',
    '$interval',
    '$timeout',
    'UserService',
    'PresentationsService',
    'PresentationsResource',
    'MarketOptionsConfig',
    'toaster',
    function (
      $rootScope,
      $scope,
      $modal,
      $interval,
      $timeout,
      UserService,
      PresentationsService,
      PresentationsResource,
      MarketOptionsConfig,
      toaster
    ) {
      var ctrl = this;

      ctrl.base_asset_url = $rootScope.base_asset_url;
      ctrl.UserService = UserService;
      ctrl.PresentationsService = PresentationsService;

      ctrl.$onDestroy = function () {
        if (ctrl.interval) {
          $interval.cancel(ctrl.interval);
        }
      };

      ctrl.days = function () {
        var days = Math.floor(ctrl.diff / (60 * 60 * 24));
        if (days < 10) {
          days = '0' + days;
        }
        return days;
      };

      ctrl.hours = function () {
        var hours = Math.floor(ctrl.diff / (60 * 60)) % 24;
        if (hours < 10) {
          hours = '0' + hours;
        }
        return hours;
      };

      ctrl.minutes = function () {
        var minutes = Math.floor(ctrl.diff / 60) % 60;
        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        return minutes;
      };

      ctrl.seconds = function () {
        var seconds = Math.floor(ctrl.diff) % 60;
        if (seconds < 10) {
          seconds = '0' + seconds;
        }
        return seconds;
      };

      ctrl.removeTile = function () {
        $cookies.put('pls_hide_preso_tile', '1');
        ctrl.tiles.splice(ctrl.tiles.indexOf(ctrl.tile), 1);
      };

      ctrl.getRsvpLink = function (pres) {
        return window.location.origin + '/events/presentations?id=' + ctrl.presentations[0].presentation_id;
      };

      $rootScope.$on('presentation.rsvped', function (evt, data) {
        $timeout(function () {
          if (ctrl.presentations[0].presentation_id === data.presentation_id) {
            ctrl.presentations[0].rsvped = 1;
          }
        });
      });

      ctrl.showDiscount = function () {
        return (
          UserService.user.is_trial ||
          UserService.user.subscription_type === 'Monthly' ||
          UserService.user.expiration * 1000 - Date.now() < 60 * 60 * 24 * 90 * 1000
        );
      };

      ctrl.getPricingUrl = function () {
        return (
          window.location.origin +
          '/pricing/' +
          MarketOptionsConfig.getMarketById(UserService.user.lead).slug +
          '?promo_code=' +
          ctrl.presentations[0].promo_code
        );
      };

      ctrl.getPricingWithReferralUrl = function () {
        return ctrl.getPricingUrl() + '&' + UserService.getReferralParam();
      };

      ctrl.goToPricing = function () {
        window.location = ctrl.getPricingUrl();
      };

      ctrl.showSuccessToaster = function () {
        toaster.success('Copied', 'URL has been copied to the clipboard.');
      };

      if (UserService.user.school) {
        ctrl.presentations = PresentationsResource.query(
          {
            next_two_weeks: 1,
            limit: 1,
            school_id: UserService.user.school ? UserService.user.school.id : 0,
          },
          function (presentations) {
            if (presentations && presentations.length) {
              presentations[0].presenter_avatar_url = PresentationsService.getPresenterAvatar(presentations[0]);
              ctrl.diff = Math.floor(presentations[0].when - Date.now() / 1000);

              if (ctrl.diff < 0) {
                ctrl.expired = true;
                ctrl.diff = Math.floor(presentations[0].when - (Date.now() / 1000 - 60 * 60 * 24 * 2));
              }

              ctrl.interval = $interval(function () {
                ctrl.diff--;

                if (ctrl.diff <= 0) {
                  $interval.cancel(ctrl.interval);
                }
              }, 1000);
            }
          }
        );
      }
    },
  ],
});
